module.exports = __webpack_public_path__ + "img/pop-icon-2.5749b33d.png";